<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <list
      v-if="trendShow"
      row-key="ClassId"
      ref="list"
      unit="用户"
      :expand-all-row="true"
      :page="page"
      :show-checkbox="true"
      :show-query="true"
      :query-params="params"
      :get-data-func="api.list"
      :getColumn="tableColumns"
      :trendColumn="trendColumn"
      :temp-params="tempParams"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="table">
        <slot name="column"></slot>
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/trend/list";
import list from "@/components/common/trendsTable/list";
import tableColumn from "@/data/basedata/inventory/categories/list.json";
// import tableParam from "@/data/basedata/inventory/categories/query.json";

export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      formApi: require("@/api/sy/formSetting").default,
      tableApi: require("@/api/sy/tableSetting").default,
      queryApi: require("@/api/sy/selectSetting").default,
      api: require("@/api/ba/class").default,
      trendColumn: tableColumn.Data,
      tableColumns: tableColumn.Data,
      trendShow: true,
      tempParams:{
        ClassType: 1,
      },
      params: {
        RankName: "",
        Status: null,
      },
    };
  },

  mounted() {
    
    // 
  },

  methods: {
    // getDateFunc() {
    //   return new Promise((resolve) => {
    //     this.api.list({ ClassType: 1 }).then((res) => {
    //       resolve({ Data: res.Data });
    //     });
    //   });
    // },
    showTable() {
      let modeName = location.hash.split("/").slice(1).join("");
      this.tableApi
        .list({ type: modeName })
        .then((res) => {
          if (res.Data === null || res.Data.length === 0) {
            return (this.trendShow = true);
          }
          if (res.Code == 0) {
            const ShowField = res.Data.map((x) => x.ShowField);

            this.tableColumns.forEach((item) => {
              const DataItem = res.Data.filter(
                (x) => x.ShowField == item.tableName
              );

              if (ShowField.indexOf(item.tableName) !== -1) {
                item.col.width = DataItem[0].ShowWidth;
                item.props.align = DataItem[0].Alignment;
                item.props.tooltip = DataItem[0].IsHidden;
              }
              // item.props.show = true
              item.props.show =
                ShowField.indexOf(item.tableName) !== -1 ? true : false;
            });
            this.trendShow = true;
            return (this.tableColumns = this.tableColumns.filter(
              (x) => x.props.show == true
            ));
          }
        })
        .then((res) => {
          this.getData();
        });
    },

    //
    showParams() {
      let modeName = location.hash.split("/").slice(1).join("");
      this.queryApi.list({ type: modeName }).then((res) => {
        if (res.Data === null || res.Data.length === 0) return;
        if (res.Code == 0) {
          const ShowField = res.Data.map((x) => x.ShowField);
          this.tableParams.forEach((item) => {
            const DataItem = res.Data.filter((x) => x.ShowField == item.field);

            if (ShowField.indexOf(item.field) !== -1) {
              item.col.labelWidth = DataItem[0].TagsWidth;
              item.col.width = DataItem[0].ShowWidth;
            }
            // item.props.show = true
            item.props.show =
              ShowField.indexOf(item.field) !== -1 ? true : false;
          });
          return (this.tableParams = this.tableParams.filter(
            (x) => x.props.show == true
          ));
        }
      });
    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>